import { Box, ListSubheader, styled } from '@mui/material';

export const ListSubheaderStyled = styled(ListSubheader)(({ theme }) => ({
  borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  minHeight: '5.6rem',
  padding: theme.spacing(4),
}));

export const ListSubheaderIconWrapperStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'flex',
}));
